var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineShape1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 30,
    viewBox: "0 0 351 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2177_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2883 6.58837C1.2883 6.58837 221.498 -0.672274 344.679 16.3311",
    stroke: "#4F8CCA",
    strokeWidth: 4.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.652239 6.69882C-0.652239 6.69882 222.38 5.14772 346.178 24.9815",
    stroke: "#4F8CCA",
    strokeWidth: 4.33333,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 29.4667,
    fill: "white",
    transform: "translate(0 0.266602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineShape1);
export default __webpack_public_path__ + "static/media/line-shape-1.00abdb960bb0c32880810bf3176f8ebe.svg";
export { ForwardRef as ReactComponent };